"use client";
import type { ReactNode } from "react";
import { LocaleProvider } from "../contexts/localeContext";
import { UserSettingsProvider } from "../contexts/userSettingsContext";
import { AiProviderProvider } from "../contexts/aiProviderContext";

export function AppSettingsProvider({ children }: { children: ReactNode }) {
  return (
    <LocaleProvider>
      <UserSettingsProvider>
        <AiProviderProvider>{children}</AiProviderProvider>
      </UserSettingsProvider>
    </LocaleProvider>
  );
}

export { useLocale } from "../contexts/localeContext";
export { useUserSettings, useDebugMode } from "../contexts/userSettingsContext";
export { useAiProvider } from "../contexts/aiProviderContext";
export type { AiProviderInfo } from "../contexts/aiProviderContext";
